<div class="sgt-representante-modalidade-comercial-faturamento-widget card card-widget">
    <div class="card-header card-header-horizontal">
        <div class="card-header-titles">
            <h6 class="card-title">
                {{title}}
            </h6>
            <small class="card-subtitle" *ngIf="subtitle">
                {{subtitle}}
            </small>
        </div>
    </div>

    <!-- <div class="card-body" *ngIf="isLoading$ | async">
        <i class='fas fa-spinner fa-pulse'></i> Carregando
    </div>     -->

    <div #pieChartContainer class="widget-chart-container"></div>
    

    <ul class="list-group list-group-flush" *ngIf="state?.data">
        <li class="list-group-item" *ngFor="let modalidadeComercial of state?.data.modalidadesComerciais">
            <span 
                class="badge widget-chart-legend"
                [style.background-color]="modalidadeComercial.color"
                [style.border-color]="modalidadeComercial.color">
            </span>
            <span>{{modalidadeComercial.nome}}</span>
            <span class="float-right">{{modalidadeComercial.faturamento?.valor | currencyFormat: 1:2:2}}</span>
        </li>
    </ul>    
</div>